import {getAuth, signInWithEmailAndPassword} from "firebase/auth";
import { message, Modal } from 'antd';
import {observable} from 'mobx';
import FirebaseService from "../../service/FirebaseService";
import Httpservice from "../../service/HttpService";
import Cookies from 'universal-cookie';
import GlobalStore from '../../store/GlobalStore';

const cookies = new Cookies();

class LoginStore {

    @observable wrongWorkspaceModalVisible = false;

    handleLoginSubmit = (values,e) => new Promise((resolve,reject)=>{
        e.preventDefault();
        let data = {
          email:values.userName.toLowerCase()
        }
        let subdomian = window.location.hostname.split('.')[0];
        if(GlobalStore.reservedSubdomains.includes(subdomian)){
          Httpservice.post('login/user/verify',data).then(res=>{
            this.LoginWithFirebase(values).then(result=>{
              resolve(result);
            })
          }).catch(err=>{
            Modal.error({title:err.response && err.response.data.message?err.response.data.message:'Error Occured'});
            reject();
          })
          
        }
        else{
          Httpservice.post('login/workspace/verify',data).then(res=>{
            if(res.data.status){
              this.LoginWithFirebase(values).then(result=>{
                resolve(result);
              })
            }
            else{
              this.wrongWorkspaceModalVisible = true;
              reject();
            }
          }).catch(err=>{
            this.wrongWorkspaceModalVisible = true;
            reject();
          })
      }
    })

    LoginWithFirebase = (values) => new Promise(resolve=>{
      const auth = getAuth();
      signInWithEmailAndPassword(auth,values.userName, values.password).then(res=>{
        var authRes = res;
        FirebaseService.getFirebaseAccessToken().then(token=>{
          Httpservice.get('user/login',token).then(res=>{
              cookies.set('token', res.data.token, { path: '/' });
              resolve(authRes);
            })
        })
      }).catch(function(error) {
        var errorMessage = error.message;
        if(error.code === 'auth/wrong-password'){
          errorMessage = 'The Password or the E-mail address is Invalid.';
        }
        resolve(error);
        Modal.error({
          title: 'Sorry!',
          content: errorMessage,
        });
      });
    })

    forgotpassword = (email) => new Promise((resolve,reject)=>{
      var data = {
        email:email
      }
      Httpservice.post('public/forgotPassword',data,'').then(res=>{
        resolve(res);
      }).catch(error=>{
        reject(error);
      })
    })

    validateVerificationCode = (code,email) =>{
      var data = {
        code:code,
        email:email
      };
      Httpservice.post('public/validateCode',data,'').then(res=>{

      })
    }


    resetPassword = (values) => new Promise((resolve,reject)=>{
      Httpservice.post('public/changepassword',values,'').then(res=>{
        resolve(res);
      }).catch(err=>{
        reject(err);
      })
    })


    checkWorkspaceExistance = (name) => new Promise(resolve=>{
      Httpservice.get(`public/workspace/existance`).then(res=>{
        resolve(res);
      })
    })

    checkWorkspaceExistanceByUname = (name) => new Promise(resolve=>{
      Httpservice.get(`public/workspace/existance/name`).then(res=>{
        resolve(res);
      })
    })

    checkWorkspaceExistanceByUname = (name) => new Promise((resolve,reject)=>{
      Httpservice.get(`public/workspace/existance/${name}`).then(res=>{
        resolve(res);
      }).catch(err=>{
        reject();
      })
    })

    sendAuthenticationOTP = (method) => new Promise((resolve,reject)=>{
      FirebaseService.getFirebaseAccessToken().then(token=>{
        Httpservice.post(`/user/2fa/otp/send`,{method},token).then(result=>{
          message.success(`OTP sent to ${result.data}`);
        }).catch(err=>{
          message.error('Unable to send OTP');
        })
      })
    })

    verifyAuthenticatorOTP = (authenticator,otp) => new Promise((resolve,reject)=>{
      FirebaseService.getFirebaseAccessToken().then(token=>{
        Httpservice.post(`user/2fa/authenticate`,{authenticator,otp},token).then((result)=>{
          if(result.data.success){
            localStorage.setItem('auth_token',result.data.token);
            resolve();
          }
        }).catch(err=>{
          reject(err && err.response && err.response.data);
        })
      })
    })
}



export default new LoginStore();